module.exports = __webpack_public_path__ + "static/media/icon06.e108a53d.svg";